export const EMPTY_VALS: string[] = [
  "",
  "--",
  "na",
  "example@vodafone.com",
  "null",
  "unknown",
  "None",
  "n/a",
  "NA",
  "N/A",
  "0",
];
export const REGEX_COMMA = /,/g;
export const REGEX_QUOTE = /"/g;
// export const REGEX_POINTLESS_NAME = /(([-_a-z0-9]{2,}) +)+(name)$/gi;
// export const REGEX_ID_CASE = /(([-_a-z0-9]{2,}) +)+(id)$/gi;
export const REGEX_CAMEL_CASE = /([a-z])([A-Z])/g;
export const WHITESPACE_REGEX = /\s+/g;
export const REGEX_DASH = /-/g;
export const REGEX_PARENTHESIS = /[()]/g;
export const REGEX_AMPERSAND = /&/g;
export const REGEX_DIMENSIONS = /^\s*([0-9]+(\.[0-9]+)?)\s*([a-z]+)\s*$/;
export const REGEX_UNDERSCORE = /_/g;
export const REGEX_SPACE = /[ \t\n\r]+/g;
// https://stackoverflow.com/questions/201323/how-can-i-validate-an-email-address-using-a-regular-expression
export const REGEX_EMAIL =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
export const REGEX_WORDS = /^[ A-Za-z0-9]+$/;
export const REGEX_ACCOUNT_ID_STARTS = /^[0-9]{12}/;
export const REGEX_UNDERSCORES = /^[^_]+_/;
export const REGEX_QUOTE_SINGLE = /'/g;
